module.exports = __webpack_public_path__ + "img/img-culture.38334c0f.png";